import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotificationTemplateComponent } from './notification-template.component';

@NgModule({
  imports: [CommonModule, FormsModule, NotificationTemplateComponent],
  exports: [NotificationTemplateComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class NotificationTemplateModule { }
